import { computed, onMounted, onUnmounted, Ref, ref, unref } from 'vue';
import type { FormActionType } from '../..';

export default function ({ formElRef }: { formElRef: Ref<FormActionType | null> }) {
  const hasRowTruncate = computed(() => {
    const formEl = unref(formElRef)?.$el;
    if (!formEl) return false;
    return formEl.classList.contains('form-row-truncate');
  });

  const showDropDown = ref(false);
  let observer: ResizeObserver;
  onMounted(() => {
    if (!hasRowTruncate.value) return;

    const formEl = unref(formElRef)?.$el;
    observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { offsetWidth, offsetHeight } = formEl || {};
        if (!offsetWidth || !offsetHeight) return;

        showDropDown.value = formEl?.classList.contains('max-row-2')
          ? entry.contentRect.height > offsetHeight
          : entry.contentRect.width > offsetWidth;
      }
    });
    const rowEl = formEl?.querySelector('.ant-row');
    rowEl && observer.observe(rowEl);
  });

  onUnmounted(() => {
    observer?.disconnect();
  });

  return { showDropDown };
}
